import { gql } from '@apollo/client'

const COACH_PREFERENCES = gql`
  query CoachSettings {
    currentUser {
      attributes {
        ... on Coach {
          bookingUrl
          freeTierLimitsReached
          preferences {
            bookNowEnabled
            acceptsLeads
          }
        }
      }
    }
  }
`

const UPDATE_COACH_PREF = gql`
  mutation UpdateCoachPreferences($input: CoachPreferencesInput!) {
    updateCoachPreferences(input: $input) {
      success
      message
      coach {
        preferences {
          acceptsLeads
          bookNowEnabled
        }
      }
    }
  }
`

export { COACH_PREFERENCES, UPDATE_COACH_PREF }
